import { useLanguageContext } from "../../../context/LanguageContext";
import LayoutPage from "../../../pages/layouts/layout/LayoutPage";
import { useLayoutEditRouteValidator } from "../../validators/layouts/LayoutEditRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useLayoutsRouteConfig from "./LayoutsRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useLayoutEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/layouts/:layout/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.layout"),
        },
      ])
    )
    .setPage(<LayoutPage />)
    .setValidator(useLayoutEditRouteValidator())
    .setParent(useLayoutsRouteConfig());
}

export default useLayoutEditRouteConfig;
